/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon24Solid = forwardRef('NetDownloadIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 1a1.5 1.5 0 0 1 1.5 1.5v11.426l4.253-3.781a1.5 1.5 0 0 1 1.994 2.242l-5.256 4.671a3.75 3.75 0 0 1-4.982 0l-5.256-4.67a1.5 1.5 0 0 1 1.994-2.243l4.253 3.78V2.5A1.5 1.5 0 0 1 12 1Z" }),
        React.createElement("path", { d: "M2 21.5A1.5 1.5 0 0 1 3.5 20h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 21.5Z" })));
});
